import {userMilestonesInterface} from '../apps/outof195/shared/user-milestones.interface'

export const userMilestonesState = {
    defaultState: {
        userMilestones: {...userMilestonesInterface},
        userMilestonesLoaded: false,
        userMilestonesError: null,
    },
    actions: {
        setUserMilestones: (milestones, state) => ({...state, userMilestones: milestones}),
        setUserMilestonesLoaded: (loaded, state) => ({...state, userMilestonesLoaded: loaded}),
        setUserMilestonesError: (error, state) => ({...state, userMilestonesError: error}),
    },
}
